<template>
	<div :class="getClasses" style="flex-wrap: wrap;">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		'noGutters': {
			type: Boolean,
			default: false
		}
	},

	computed: {
		getClasses() {
			return [
				'columns', {
					'is-gapless': this.noGutters
				}
			];
		}
	}

};
</script>
